import { Component, OnDestroy, OnInit, inject } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { ISurgery } from '@app/core/contracts/dto';
import { ModalController } from '@ionic/angular';
import { formatISO, parseISO, startOfDay } from 'date-fns';
import { Subject } from 'rxjs';

@Component({
    selector: 'app-add-surgery',
    templateUrl: './add-surgery.component.html',
    styleUrls: ['./add-surgery.component.scss'],
    standalone: false
})
export class AddSurgeryComponent implements OnInit, OnDestroy {
  private modalController = inject(ModalController);

  componentDestroyed$: Subject<boolean> = new Subject();

  surgeryForm: FormGroup;
  date: FormControl;
  description: FormControl;
  surgeon: FormControl;

  ngOnInit() {
    this.createFormControls();
    this.createForm();
  }

  createFormControls() {
    this.date = new FormControl(formatISO(startOfDay(new Date())), Validators.compose([Validators.required]));
    this.description = new FormControl('', [Validators.required, Validators.minLength(3)]);

    this.surgeon = new FormControl('', [Validators.required, Validators.minLength(3)]);
  }

  createForm() {
    this.surgeryForm = new FormGroup({
      date: this.date,
      description: this.description,
      surgeon: this.surgeon
    });
  }

  addSurgery() {
    if (!this.surgeryForm.valid) {
      return;
    }

    const item: ISurgery = {
      date: startOfDay(parseISO(this.date.value)).valueOf(),
      description: this.description.value,
      surgeon: this.surgeon.value
    };

    this.modalController.dismiss(item);
  }

  cancel() {
    this.modalController.dismiss();
  }

  ngOnDestroy() {
    this.componentDestroyed$.next(true);
    this.componentDestroyed$.complete();
  }
}
